import type { Testimonial } from '@/types';

// Real customer testimonials from the original DrBurns' ReLeaf website (archived 2020–2021).
// Verbatim quotes — not generated. FTC-compliant.
export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'C. C.',
    location: 'Arizona',
    quote:
      "Dr Burns, this may not be a surprise to you, but I am having some pretty amazing results with CBD Pure in just 3 nights! I am sleeping a little better. The CBD has already exceeded my expectations! Thanks so much for helping me on this journey.",
    rating: 5,
    condition: 'General wellness',
    verified: true,
    order: 1,
  },
  {
    id: 't2',
    name: 'T. L.',
    location: 'Arizona',
    quote:
      "I started using DrBurns Pure CBD for shoulder pain from a lifting injury. The CBD relieves my pain and inflammation. I also use DrBurns Muscle & Joint Ointment for quick relief — works quickly and my shoulder feels better before going to bed at night.",
    rating: 5,
    condition: 'Pain relief',
    verified: true,
    order: 2,
  },
  {
    id: 't3',
    name: 'Kent Monken',
    location: 'Arizona',
    quote:
      "I use the scented cream for my sore shoulder and it has provided freedom from pain. Dr. Burns cream is the best. I always get results.",
    rating: 5,
    condition: 'Topical relief',
    verified: true,
    order: 3,
  },
  {
    id: 't4',
    name: 'Mark Jance',
    location: 'Arizona',
    quote:
      "The benefits of the GI Assist are remarkable — my stomach no longer feels jumpy. My nausea and vomiting has decreased I'd say by 90%. I'm blessed the rest of the day.",
    rating: 5,
    condition: 'Digestive support',
    verified: true,
    order: 4,
  },
];
